export default {
  namespaced: true,

  state: {
    DAY_IN_MIN: 1440,
    timeInterval: 30,
    timeModulo: 2,
    dayInterval: 7,
    activeTimeBlockWithFK: null,
    activeTimeBlockConflict: null
  },

  mutations: {
    SET_TIME_INTERVAL(state, newVal) {
      state.timeInterval = newVal;
      state.timeModulo = 60 / newVal;
    },
    SET_DAY_INTERVAL(state, newVal) {
      state.dayInterval = newVal;
    },
    SET_ACTIVE_TIME_BLOCK(state, timeBlock) {
      state.activeTimeBlockWithFK = timeBlock;
    },
    SET_ACTIVE_TIME_BLOCK_CONFLICT(state, timeBlock) {
      state.activeTimeBlockConflict = timeBlock;
    }
  },

  actions: {
    setTimeInterval({ commit }, newVal) {
      commit('SET_TIME_INTERVAL', newVal);
    },
    setDayInterval({ commit }, newVal) {
      commit('SET_DAY_INTERVAL', newVal);
    },
    setActiveTerminEntry({ commit }, timeBlock) {
      commit('SET_ACTIVE_TIME_BLOCK', timeBlock);
    },
    setActiveTerminConflict({ commit }, timeBlock) {
      commit('SET_ACTIVE_TIME_BLOCK_CONFLICT', timeBlock);
    }
  },

  getters: {
    calcRowCountFromTimeInterval: state => {
      return state.DAY_IN_MIN / state.timeInterval;
    },
    calcTimeModulo: state => {
      return 60 / state.timeInterval;
    }
  }
};
